const bankOptions = [
  {
    value: "001",
    text: "001. Banco do Brasil",
    imgUrl: "https://portal.delend.com.br/static/media/logo-banco-brasil.png",
  },
  {
    value: "208",
    text: "208. Banco BTG Pactual SA Unit",
    imgUrl: "https://portal.delend.com.br/static/media/btg-pactual.svg",
  },
  {
    value: "237",
    text: "237. Banco Bradesco",
    imgUrl: "https://portal.delend.com.br/static/media/logo-bradesco.png",
  },
  {
    value: "033",
    text: "033. Banco Santander",
    imgUrl:
      "https://portal.delend.com.br/static/media/logo-banco-santander.png",
  },
  {
    value: "104",
    text: "104. Caixa Econômica Federal",
    imgUrl: "https://portal.delend.com.br/static/media/logo-caixa.png",
  },
  {
    value: "341",
    text: "341. Itaú Unibanco",
    imgUrl: "https://portal.delend.com.br/static/media/logo-banco-itau.png",
  },
  {
    value: "260",
    text: "260. Nubank",
    imgUrl: "https://portal.delend.com.br/static/media/logo-nubank.png",
  },
  {
    value: "380",
    text: "380. PicPay",
    imgUrl: "https://portal.delend.com.br/static/media/logo-pic-pay.png",
  },
  {
    value: "623",
    text: "623. Banco Pan",
    imgUrl: "https://portal.delend.com.br/static/media/logo-banco-pan.png",
  },
  {
    value: "077",
    text: "077. Banco Inter",
    imgUrl: "https://portal.delend.com.br/static/media/logo-Inter.png",
  },
];

export default bankOptions;
